const heroSplit = {
    init() {
        const panels = document.querySelectorAll('.hero-split__panel[href]');

        panels.forEach(function (panel) {
            const circle = panel.querySelector('.hero-split__panel-link');

            if (!circle) {
                return;
            }

            panel.addEventListener('mouseenter', function () {
                circle.classList.add('is-active');
            });

            panel.addEventListener('mouseleave', function () {
                circle.classList.remove('is-active');
            });

            panel.addEventListener('mousemove', function (e) {
                const rect = panel.getBoundingClientRect();
                const x = e.clientX - rect.left - circle.offsetWidth / 2;
                const y = e.clientY - rect.top - circle.offsetHeight / 2;

                circle.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(1.05)';
            });
        });
    }
}

heroSplit.init();
